import { connect } from 'react-redux';
import { fetchApps } from '../../redux/actions/appActions';
import AppsList from './AppsList';
import { push } from 'connected-react-router';
import { CREATE_APP_PATH } from '../../utils/constants';

const mapStateToProps = ({ apps }) => ({ ...apps });
const mapDispatchToProps = dispatch => ({
  fetchAllApps: () => dispatch(fetchApps()),
  goToCreateAppPage: () => dispatch(push(CREATE_APP_PATH))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppsList);



// WEBPACK FOOTER //
// ./src/components/apps/AppsContainer.js